import { AxiosResponse } from 'axios';
import apiBack from './api';
import { Pagination, ProcessStatisticsDTO } from '../types/ProcessStatistics.d';

export class ProcessesStatisticsService {
  static async getProcessesStatistics(
    limit: number,
    page: number,
    offset?: number,
  ): Promise<AxiosResponse<Pagination<ProcessStatisticsDTO[]>>> {
    const response = await apiBack.get<Pagination<ProcessStatisticsDTO[]>>('processes/statistics', {
      validateStatus: status => [200].includes(status),
      params: { limit, page, offset },
    });
    return response;
  }

  static async getGeneralStatistics(): Promise<AxiosResponse> {
    const response = await apiBack.get('/home/general-statistics', {
      validateStatus: status => [200].includes(status),
    });

    return response;
  }
}
